export default {
  title: 'ActivationdeMAXHUB',
  instruction: 'Remplissezcorrectementlesinformationsd’utilisateuretdevendeur,pourgarantirlebondéroulementduserviceaprès-ventes',
  dealername: 'Nomduvendeur',
  dealerplaceholder: 'Nomduvendeur',
  companyname: 'Nomdesociété',
  companyplaceholder: 'Nomdesociété',
  tele: 'Informationsdecontact',
  teleplaceholder: 'Téléphonemobile',
  district: 'Sélectionderégion',
  distplaceholder: 'Informationsderégion',
  address: 'Adressedétaillée',
  addrplaceholder: 'Adressedétaillée',
  activebtn: 'Obtenirlecoded’activation',
  confirmbtn: 'Confirmer',
  cancelbtn: 'Annuler',
  dialogmessage: 'Leformatdenumérodetéléphonemobileestincorrect,saisissez-ledenouveau',
  dialogbtn: 'Confirmer',
  errortitle: 'Impossibled’ouvrir',
  errorinfo1: 'Essayezlavérificationduréseau',
  errorinfo2: 'Numérod’appeld’assistance400-168-9545',
  nosn: 'L’appareilnepeutêtreactivécaraucunnumérodesérien’estsaisit',
  activepagetitle: 'Coded’activation',
  activepagehint: 'Saisissezlecoded’activationpouractiverl’appareil',
  finish: 'Finir',
  search: 'Fouille à proximité'
};



// WEBPACK FOOTER //
// ./src/i18n/_fr.js